export const DISTRIBUTORS_HUB = [1, 7]

// Tempo de espera após o usuário parar de digitar antes de disparar a busca
// de produtos (/list-products e /list-products-public), para evitar uma
// requisição a cada tecla.
export const SEARCH_DEBOUNCE_MS = 1500

// Direciona para o relacional
export const LIST_BRAND_ATTENDANT = [128, 27, 3]

// Direciona para o relacional na jornada digital
export const BRANDS_TO_REDIRECT_FOR_SALES = [128, 27, 3]

export const BRAND_REMOVED_FROM_ANVISA_MESSAGE =
  'Atenção: esta marca foi removida provisoriamente da lista automática da Anvisa. Isso pode impactar o processo de importação para pacientes que vão iniciar o tratamento com esta marca. Fale com nosso time de atendimento para mais informações.'

export const DELIVERY_MESSAGES = {
  HUB_IMPORTED: 'Importado: entrega em até 15 dias úteis.',
  NON_HUB: 'Entrega em até 25 dias úteis.',
  NATIONAL: 'Entrega de origem nacional. Receba em até 5 dias úteis.',
  OUT_OF_STOCK_HUB: 'Possível maior tempo de entrega',
  SUPPLEMENT_FREE_SHIPPING: 'Frete grátis'
}

export const PRODUCT_LABELS = {
  PRESCRIPTION_REQUIRED: 'Necessário prescrição',
  FREE_SHIPPING: 'Frete grátis',
  PRICE_ON_CONSULTATION: 'Preço sob consulta'
}

export const ASSISTANT_BUTTON_TEXTS = {
  PRESCRIBE: 'Prescrever',
  SELECTED: 'Selecionado'
}
